
export class StringUtils {
  static clean(obj: any): any {
    // tslint:disable-next-line: forin
    for (const propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
      if (Array.isArray(obj[propName]) && obj[propName].length === 0){
        delete obj[propName];
      }
    }
    return obj;
  }

  static toTitleCase(str: any): string {
    return str.replace(
      /\w\S*/g,
      (txt: string) => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }

}
